// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-author-spotlight__paragraph + .c-author-spotlight__paragraph {\n    margin-top: 12px\n}\n@media (min-width: 40em) {\n.c-author-spotlight__paragraph + .c-author-spotlight__paragraph {\n      margin-top: 20px\n}\n}\n", ""]);
// Exports
module.exports = exports;
